import axios from "axios";
import { apiBaseUrl } from "../config/appConfig";
import { API_TIMEOUT } from "../constants";
import { storage } from "../utils";

const httpClient = axios.create({
  baseURL: apiBaseUrl,
  timeout: API_TIMEOUT,
});

httpClient.interceptors.request.use((config) => {
  const token = storage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default httpClient;
